(() => {
  const popup = document.getElementById('DistrictPopup');
  if (!popup) return;

  const closeButtons = popup.querySelectorAll('[data-district-popup-close]');
  let previousFocus = null;

  const openPopup = () => {
    previousFocus = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('district-popup-lock');
    const close = popup.querySelector('.district-popup__close');
    if (close) close.focus({ preventScroll: true });
  };

  const closePopup = () => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('district-popup-lock');
    if (previousFocus && previousFocus.focus) previousFocus.focus({ preventScroll: true });
  };

  closeButtons.forEach((el) => el.addEventListener('click', closePopup));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup();
    }
  });

  // Apertura automatica ad ogni caricamento pagina quando il popup è attivo.
  // Se sul sito originale era impostata una frequenza diversa, basta modificare qui.
  window.addEventListener('load', () => {
    window.setTimeout(openPopup, 350);
  });
})();